import {render} from "@testing-library/react";
import React, {useState, useEffect, useRef} from "react";
import {verifyLoginCode, setAuthCode} from "../authRequests";
import {loadDataForPatientLogin, crud} from "../crudRequests";
import clientInfo from "../additional_files/loginInfo";
import axios from "axios";
import {FiHash} from "react-icons/fi";
export default function CodeForm({logingData, navigate, sendCodeData, org}) {
  const [code, setCode] = useState("");
  const [serverError, setServerError] = useState("");
  const [authError, setAuthError] = useState("");
  const [loading, setLoading] = useState("");
  const [sendingCode, setSendingCode] = useState("");
  const [loadingSuccses, setLoadingSuccses] = useState(false);
  function login(e) {
    e.preventDefault();
    setLoading(true);
    verifyLoginCode({
      code,
      ...sendCodeData,
    })
      .then(async (res) => {
        setLoading(false);
        setLoadingSuccses(true);
        // The right code answers with the record and the session's token,
        // which replaces the second-step token the password step gave.
        const {jwt: sessionJwt, ...record} = res.data || {};
        const jwt = sessionJwt || logingData.jwt;
        let data = {...logingData, jwt, [logingData.userType]: record};
        let jsonIp = await axios({url: "https://api.ipify.org?format=json"});

        let userId =
          logingData.userType === "relationship"
            ? logingData.relationship?.rid
            : logingData.patient?.pid;

        crud({jwt}, [
          {
            db: logingData.db,
            collection: "security",
            parameters: [
              {userId},
              {
                $push: {
                  logins: {
                    ip: jsonIp.data.ip,
                    client: clientInfo(),
                    timestamp: new Date(),
                  },
                },
              },
              {upsert: true},
            ],
            method: "findOneAndUpdate",
          },
        ]);

        loadDataForPatientLogin(data, navigate);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 401) {
          setLoading(false);
          setAuthError(true);
        } else if (err.response.status === 404 || err.response.status === 500) {
          setServerError(true);
        }
      });
  }

  return (
    <div className="w-full max-w-md">
      {loadingSuccses ? (
        <div className="border p-[6.5rem] rounded-md">
          <div className="flex justify-center align-middle">
            <img src="/images/loader.gif" className="h-36" alt="Loading" />
          </div>
        </div>
      ) : (
        <form
          onSubmit={login}
          className="w-full border border-gray-100 bg-white/80 backdrop-blur-md shadow-2xl rounded-2xl p-8 sm:p-10"
        >
          {org?.logo ? (
            <img
              src={org.logo}
              className="w-40 mx-auto mb-6"
              alt={`${org?.name || "Clinic"} logo`}
            />
          ) : (
            <img
              src="/images/logo.png"
              className="w-40 mx-auto mb-6"
              alt="Brightlight logo"
            />
          )}
          <div className="text-center mb-4">
            <h2 className="text-xl font-semibold text-slate-800">
              Two-step verification
            </h2>
            <p className="text-sm text-slate-500">
              Enter the code we sent to complete sign in
            </p>
          </div>
          {authError && (
            <div className="w-full flex justify-center">
              <div
                role="alert"
                className="mb-2 w-full rounded-xl border border-red-200/70 bg-red-50/80 px-4 py-2.5 text-red-700 shadow-sm backdrop-blur"
              >
                <div className="flex items-start gap-3 text-left">
                  <span className="mt-1 inline-block h-2 w-2 rounded-full bg-red-400 ring-4 ring-red-100"></span>
                  <div className="flex-1">
                    <p className="font-semibold">Verification failed</p>
                    <p className="text-sm">The code you entered is invalid.</p>
                  </div>
                </div>
              </div>
            </div>
          )}
          {serverError && (
            <div className="w-full flex justify-center">
              <div
                role="alert"
                className="mb-2 w-full rounded-xl border border-amber-200/70 bg-amber-50/80 px-4 py-2.5 text-amber-800 shadow-sm backdrop-blur"
              >
                <div className="flex items-start gap-3 text-left">
                  <span className="mt-1 inline-block h-2 w-2 rounded-full bg-amber-400 ring-4 ring-amber-100"></span>
                  <div className="flex-1">
                    <p className="font-semibold">Something went wrong</p>
                    <p className="text-sm">Please try again in a moment.</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="input-group with-icon relative">
            <FiHash className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              id="code"
              required
              autoComplete="one-time-code"
              className="input w-full py-3 pl-10 pr-4 rounded-lg my-2 bg-white border border-gray-200 focus:border-[#6772e5] focus:ring-2 focus:ring-[#6772e5]/40 transition tracking-widest"
              onChange={(e) => {
                setAuthError(false);
                setCode(e.target.value);
              }}
            />
            <label htmlFor="code" className="input-label">
              Authentication code
            </label>
          </div>
          <div className="flex items-center justify-between mt-2">
            <span
              className="text-[#6772e5] font-medium text-xs mt-2 cursor-pointer flex hover:underline"
              onClick={() => {
                if (!sendingCode) {
                  setSendingCode(true);
                  setAuthCode(sendCodeData)
                    .then(() => {
                      setSendingCode(false);
                    })
                    .catch((e) => {
                      console.log(e.message);
                      setSendingCode(false);
                    });
                }
              }}
            >
              {sendingCode ? "Sending email..." : "Resend email."}
              {sendingCode && (
                <span className="">
                  <svg
                    className="animate-spin -mb-0.5 ml-1 -mr-1 h-4 w-4 text-dark"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                </span>
              )}
            </span>

            <button
              type="submit"
              className="inline-flex items-center justify-center p-2.5 px-5 rounded-lg my-2 bg-[#6772e5] hover:bg-[#5b63d3] text-white font-medium text-sm cursor-pointer shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#6772e5] transition-all duration-150"
            >
              Confirm{" "}
              {loading && (
                <span className="">
                  <svg
                    className="animate-spin -mb-0.5 ml-1 -mr-1 h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                </span>
              )}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
